import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { isGuid, isNullOrUndefined, isValidLanguage } from '../../store/storeFunctions';
import { apiPost, getHostApi, getHostUrl } from '../../store/apiWrapper';
import { reportActions } from '../../store/reportStore';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { Formik, Form } from 'formik';
import { FileUpload } from '../common/fileUpload';
import { Translate } from 'react-localize-redux';
import classnames from 'classnames';
import ReportSection from '../common/reportSection';
import ReportExpander from '../common/reportExpander';
import { Circles } from '../common/loadingComponent';
import Message from '../common/message';

import "../report/report.scss";

class CustomizableMspReport extends React.Component {

    state = {
        reloading: false
    }

    componentDidMount() {
        this.props.requestGetReportSettings(this.props.match.params.entityId, 'CustomizableMspReport');
        this.pushSubject();
    }

    componentWillUnmount() {
        if (this.props.sections) {
            this.props.restoreConfig();
        }
        this.props.toggleSectionEditMode(false);
        this.props.onLeavingReport();
    }

    pushSubject = () => {
        const entityId = this.getFirstEntityId();
        const entityInfo = this.props.entityInfos[entityId] && this.props.entityInfos[entityId].result;
        if (isNullOrUndefined(entityInfo))
            return null;

        this.props.pushSubject(entityInfo);
    }

    getFirstEntityId = () => {
        return window.location.pathname.match(/\d+/)[0];
    }

    render() {

        const activeLanguage = this.props.user.language;
        return <div className="ident-data content-root content-root-narrow">
            {(!isNullOrUndefined(this.props.customizableMspImportData) && this.props.customizableMspImportData.invalidFile) && <Message type="error" message="" style={{ marginTop: "1em" }}>
                <>
                    <Translate id={`Search.Common.Bulk.ErrorFile`} />
                    <a href={this.getBulkTempFileUrl(this.props.customizableMspImportData.errorFile)} target="_blank">
                        <Translate id='Search.Common.Bulk.ErrorFileLink' />
                    </a>
                </>
            </Message>}
            {(!isNullOrUndefined(this.props.customizableMspImportData) && this.props.customizableMspImportData.hasItems) &&
                <Message type="info" message={this.props.translate("Common.RecalculateFromFile") + " " + this.props.customizableMspImportData.fileName} style={{ marginTop: "1em" }}>
                </Message>}
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{

                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    this.submitForm(values);
                }}>
                {({ values, setFieldValue, errors, resetForm }) => (
                    <Form>
                        <div className="columns is-desktop">
                            <div className='column'>
                                <div className='card card-special' style={{ marginTop: "2em", marginBottom: "2em" }}>
                                    <div className='card-body'>
                                        <div className='columns is-centered is-multiline'>
                                            <div className="column is-12" style={{ paddingBottom: "1.5em" }}>
                                                <div className="tile is-vertical" >
                                                    <div className="tile is-child is-centered" style={{ textAlign: 'center' }}>
                                                        <label>
                                                            <b>
                                                                <Translate id='Search.Common.BulkFile' />
                                                            </b>
                                                        </label>
                                                    </div>
                                                    <div className="tile is-child">
                                                        <FileUpload className="fileupload-button" customLabel={true} name='bulkFile'
                                                            callback={(result) => setFieldValue("bulkFile", result)}
                                                        >
                                                            <a className="link-functional" id="bulk_template"
                                                                href={this.getBulkTemplateUrl(activeLanguage)}
                                                                style={{ padding: "1em" }}
                                                            >
                                                                <Translate id='Search.Common.BulkTemplate' />
                                                            </a>
                                                        </FileUpload>
                                                    </div>
                                                    <div className="tile is-child is-centered" style={{ textAlign: 'center' }}>
                                                        <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                                            type='submit'
                                                            disabled={isNullOrUndefined(values.bulkFile)}
                                                            style={{ fontWeight: 600 }}
                                                            onClick={() => this.props.onSubmit}
                                                        >
                                                            <Translate id="Common.Recalculate" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Form>)}
            </Formik>
            <ReportExpander allowExpandAll={false} allowSectionSelector={false} />

            {this.state.reloading && <Circles />}
            {!this.state.reloading && <div className="report-unlimited-wrapper">
                {!this.props.sections && <Circles />}
                {(this.props.sections && !isNullOrUndefined(this.props.customizableMspImportData) && !isNullOrUndefined(this.props.customizableMspImportData.fileName)) && <div style={{ textAlign: 'end', marginBottom: "1em" }}><Translate id="Common.RecalculateFromFile" /> <b>{this.props.customizableMspImportData.fileName}</b></div>}
                {this.props.sections && this.props.sections.map(s => <ReportSection key={s.id + '-' + s.orderId} sectionId={s.id} />)}
            </div>}
        </div>;

    };

    getBulkTemplateUrl(languageCode) {
        const entityId = this.props.match.params.entityId;
        const shareRgx = /^[0-9.,]+$/gi;
        const share = this.props.economicGroupSettings.share;
        const langCode = isValidLanguage(languageCode) ? languageCode : "sk-SK";
        return isNaN(parseInt(entityId)) || !shareRgx.test(share) ? "#" : `${getHostApi()}/api/search/bulk/template/msp/${entityId}/${share}/${langCode}`;
    }

    getBulkTempFileUrl(file) {
        return !isGuid(file) ? "#" : `${getHostUrl()}/files/bulk/error/${file}`;
    }

    submitForm = (values) => {
        this.setState({ reloading: true });
        apiPost(
            `${getHostApi()}/api/search/customizable-msp/import`,
            null,
            {
                fileName: values.bulkFile.fileName,
                fileBytes: values.bulkFile.fileBytes,
                contentType: values.bulkFile.contentType,
                entityId: parseInt(this.props.match.params.entityId)
            },
            (data) => {
                // this.setState({ bulkCheck: data.data }); // TODO ADAM
                if (data.hasData) {
                    this.props.setCustomizableMspImportData(data);
                    this.props.setCompanyInDifficultyExportUsed(false);
                }
                else {
                    // this.onError(data.data);
                }
                this.setState({ reloading: false });
            },
            (data) => {
                // this.onError(data.data)
            }
        );
    }
}

export default withRouter(connect(
    state => ({ ...state.entityIdentRow, ...state.report, user: state.userContext }),
    dispatch => bindActionCreators({ ...reportActions, ...lastSubjectActions }, dispatch)
)(CustomizableMspReport));